<template>
  <div>
    <nav class="border-b border-gray-300 px-2 md:px-0 py-2">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'organization_details', params: { orgId: orgId }}">
              Organization
            </router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'venues'}">Networks</router-link>
            <span class="mx-2">/</span>
            <span>Network profile</span>  
          </div>
          <div class="text-xl">
            {{ venue.name }} profile
          </div>
        </div> 
        <div class="">          
          <div class="md:ml-2 mt-2 md:mt-0" style="z-index: 0">
              <date-range-picker
                  ref="dateRange"
                  v-model="filters.dateRange"
                  :opens="picker.opens"
                  :locale-data="picker.locale"
                  :minDate="picker.minDate"
                  :maxDate="picker.maxDate"
                  :singleDatePicker="picker.singleDatePicker"
                  :timePicker="picker.timePicker"
                  :timePicker24Hour="picker.timePicker24Hour"
                  :showWeekNumbers="picker.showWeekNumbers"
                  :showDropdowns="picker.showDropdowns"
                  :autoApply="picker.autoApply"
                  :linkedCalendars="picker.linkedCalendars"
                  :dateFormat="picker.dateFormat">
              </date-range-picker>
            </div>
            <br>
            <div class="inline-block relative float-right">
            <router-link :to="{name:'venue_details', params: {venueId: venueId, path:'new_access_point'}}" v-if="$store.getters.can('create_ap')"
                         style="color: white !important;"
                         class="bg-teal-500 text-white hover:bg-teal-700 py-2 px-4 rounded-sm inline-flex items-center">
              New access point
            </router-link>
          </div>
        </div>
      </div>
    </nav>
    <div class="py-4 md:px-0 px-2">
      <div class="md:flex block">
        <div class="w-full rounded-lg  overflow-hidden  md:max-w-xs mb-3">
          <div class=" bg-white rounded-lg border shadow-sm">
            <img src="https://www.connectify.me/wp-content/uploads/hotspot-wifi-range-booster-904x452.png"
                 class="w-full hidden md:block"/>
            <div class="text-center px-3 pb-6 pt-2">
              <h3 class="text-black text-sm bold font-sans">{{ venue.name || '' }}</h3>
              <p class="mt-2 font-sans font-light text-grey-dark">Phone: {{ venue.phone_number || 'Not available' }}</p>
              <p class=" font-sans font-light text-grey-dark">Email: {{ venue.email || 'Not available' }}</p>
            </div>

            <ul class="mt-2 flex flex-wrap md:block">
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'venue_details', params: {venueId: venueId, path:'sessions'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="eye" size="16" class="mr-4"></feather>
                  Overview
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2 hidden">
                <router-link :to="{name:'venue_details', params: {venueId: venueId, path:'layout'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="map" size="16" class="mr-4"></feather>
                  Layout
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'venue_details', params: {venueId: venueId, path:'designer'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="activity" size="16" class="mr-4"></feather>
                  Layout Designer
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'venue_details', params: {venueId: venueId, path:'connections'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="activity" size="16" class="mr-4"></feather>
                  Connections
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'venue_details', params: {path: 'devices'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="airplay" size="16" class="mr-4"></feather>
                  Devices
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'venue_details', params: {venueId: venueId, path:'customers'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="users" size="16" class="mr-4"></feather>
                  Clients
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2 ">
                <router-link :to="{name:'venue_details', params: {venueId: venueId, path:'access_points'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="wifi" size="16" class="mr-4"></feather>
                  Access points
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2 hidden ">
                <router-link :to="{name:'venue_details', params: {venueId: venueId, path:'access_points'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="tablet" size="16" class="mr-4"></feather>
                  Splash pages
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2 ">
                <router-link :to="{name:'venue_details', params: {venueId: venueId, path:'settings'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="sliders" size="16" class="mr-4"></feather>
                  Settings
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="w-full mt-3 md:mt-0 md:mx-4 ">

          <Connections
              :filters="apFilters"
              :venues="[venueId]"
              :breadcrumb="false"
              v-if="path === 'connections'"/>
          <Maps
              :filters="apFilters"
              :venueId="venueId"
              :breadcrumb="false"
              v-else-if="path === 'layout'"/>
          <LayoutDesigner
              :filters="apFilters"
              :venueId="venueId"
              title="Network layout designer"
              :breadcrumb="false"
              v-else-if="path === 'designer'"/>
          <Customers
              :filters="apFilters"
              :venues="[venueId]"
              :breadcrumb="false"
              v-else-if="path === 'customers'"/>
          <Devices
              :filters="apFilters"
              :venues="[venueId]"
              :breadcrumb="false"
              v-else-if="path === 'devices'"/>
          <AccessPointsComponent
              :breadcrumb="false"
              :title="'Venue access points'"
              :venues="[venueId]"
              :filters="apFilters"
              v-else-if="path === 'access_points'"/>
          <UpdateOrCreateAccessPointComponent
              :venue-id="venueId"
              :breadcrumb="false"
              v-else-if="path === 'new_access_point'"/>
          <UpdateOrCreateVenueComponent :venue-id="venueId" v-else-if="path === 'settings'"/>
          <div v-else>
            <!--              Overview numbers-->
            <div class="grid gap-4 grid-cols-4 justify-between">
              <div class="flex bg-teal-500 text-white shadow-sm rounded">
                <div class="p-4 py-5">
                  <div class="font-bold text-xl">{{ venue.accessPointsCount || 0 }}</div>
                  Access points
                </div>
              </div>
              <div class="flex bg-white shadow-sm  rounded">
                <div class="p-4 py-5">
                  <div class="font-bold text-xl">{{ venue.customersCount || 0 }}</div>
                  Unique Clients
                </div>
              </div>
              <div class="flex bg-green-700 text-white  shadow-sm  rounded">
                <div class="p-4 py-5">
                  <div class="font-bold text-xl">{{ venue.connectionsCount || 0 }}</div>
                  Total Connections
                </div>
              </div>
              <div class="flex bg-red-700 text-white shadow-sm  rounded">
                <div class="p-4 py-5">
                  <div class="font-bold text-xl">{{ venue.onlineConnectionsCount || 0 }}</div>
                  Currently Connected
                </div>
              </div>
            </div>
            <!--  End overview numbers-->

            <!--              connections graph-->
            <div class="block md:flex mt-4">
              <div class="w-full md:pr-2 ">
                <DwellTime :filters="filters"/>
              </div>              
            </div><br>
            <div class="w-full md:pl-2 ">
                <ConnectionsGraph :filters="filters"/>
            </div>
            <!--              connections graph-->
            <div class="block md:flex mt-4">
              <!-- <Heatmap class="w-full md:pr-2 md:w-1/2"/>-->
              <connections class="w-full md:pl-2" :venues="[venueId]" :online="true" :breadcrumb="false" :filters="filters"/>
            </div>
            <LayoutDesigner :venue-id="venueId" :show-heat-map="true" :title="'Traffic flow'" class="w-full"/>
            <!--              End connections graph-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AccessPointsComponent from "../../components/AccessPointsComponent";
import UpdateOrCreateVenueComponent from "../../components/UpdateOrCreateVenueComponent";
import DwellTime from "@/modules/Dashboards/Dwelltime";
import ConnectionsGraph from "@/modules/Dashboards/ConnectionsGraph";
import moment from "moment";
import Connections from "@/modules/connections/Connections";
import GraphQl from "@/services/graphql.service";
import Customers from "@/modules/customers/Customers";
import Devices from "@/modules/devices/Devices";
import UpdateOrCreateAccessPointComponent from "@/components/UpdateOrCreateAccessPointComponent";
import Maps from "@/modules/core/Maps";
import LayoutDesigner from "@/modules/venues/LayoutDesigner";
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';


export default {
  name: "VenueDetails",
  components: {
    LayoutDesigner,
    Maps,
    UpdateOrCreateAccessPointComponent,
    Devices,
    Customers,
    Connections,
    ConnectionsGraph,
    DateRangePicker,
    DwellTime,  UpdateOrCreateVenueComponent, AccessPointsComponent
  },
  props: {
    venueId: String,
    path: String
  },
  data() {
    return {
      venue: Object,
      orgId: this.$store.getters.orgId,
      apFilters: {
        venue_id: this.venueId
      },
      filters: {
        dateRange: {
          //startDate: moment().subtract(1, 'year').format("YYYY-MM-DD HH:MM"),
          startDate: moment().startOf("day").toDate(),
          endDate: moment().endOf("day").toDate()
          //endDate: moment(moment.now()).format("YYYY-MM-DD HH:MM")
        },
        venues: [{name: '', id: this.venueId}],
      },
      picker: {
        opens: "left",
        timePicker: false,
        autoApply: false,
        linkedCalendars: true,
        maxDate: moment(moment.now()).format("YYYY-MM-DD"),
        locale: {
          format: 'dd/mm/yyyy',
          direction: "ltr", //direction of text format: "DD-MM-YYYY", //format of the dates displayed
          separator: " - ", //separator between the two ranges
          applyLabel: "Apply",
          cancelLabel: "Cancel",
          weekLabel: "W",
          customRangeLabel: "Custom Range",
          daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
          monthNames: moment.monthsShort(), //array of month names - see moment documentions for details
          firstDay: 1 //ISO first day of week - see moment documenations for details
        }

      },
    }
  },
  mounted() {
    this.getVenue();
  },
  methods: {
    getVenue() {
      GraphQl.sendRequest('{venue(id:"' + this.venueId + '") {name email phone_number accessPointsCount connectionsCount onlineConnectionsCount customersCount}}')
          .then(response => {
            this.venue = response.venue;
          }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>
<style scoped>

</style>